/**
 * Created by Claude on 2024
 * Description: 千人画师征集活动 API
 */
import { rpNft } from "@/http";

export default {
  // 获取创作者的作品列表
  getRecentWorks(params: { creatorId: string; cursor?: string }) {
    return rpNft.post("/gw/token/get-by-creator", params);
  },

  // 提交报名信息
  submitRecruitment(params: { tokenIds: string[]; price: number }) {
    return rpNft.post("/gw/activity/post-form", params);
  },
};
